export default "__VITE_ASSET__l2D2Pzb9__"